/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { NgModule } from "@angular/core";
import { ActionModalComponent } from "./action-modal.component";

@NgModule({
  declarations: [ActionModalComponent]
})
export class ActionModalModule {}
